import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopy from './index.vue';

var InboundOrderBookingCopyBookingPage = function (_super) {
  __extends(InboundOrderBookingCopyBookingPage, _super);

  function InboundOrderBookingCopyBookingPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InboundOrderBookingCopyBookingPage = __decorate([Component({
    components: {
      AddEditCopy: AddEditCopy
    }
  })], InboundOrderBookingCopyBookingPage);
  return InboundOrderBookingCopyBookingPage;
}(Vue);

export default InboundOrderBookingCopyBookingPage;